import { render, staticRenderFns } from "./Extensao.vue?vue&type=template&id=0e7f00dd&"
import script from "./Extensao.vue?vue&type=script&lang=js&"
export * from "./Extensao.vue?vue&type=script&lang=js&"
import style0 from "./Extensao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports